class ScaleBar {
	constructor(scale, tl) {
		/** @var TimelineScale */
		this._scale = scale;
		this._marks = [];
		this._days = [];
		this._months = [];

		this._bar = UI.div('row timelineScale', [
			this._monthBar = UI.div(),
			this._dayBar = UI.div(),
			this._markBar = UI.div()
		], {
			'mouseover': tl.mouseover.bind(tl),
			'mousedown touchstart': tl.mousedown.bind(tl),
			'mouseout': tl.mouseout.bind(tl),
			'mouseup touchend': tl.mouseup.bind(tl)
		});
	}

	get firstMark() {return this._marks[0];}
	get lastMark() {return this._marks[this._marks.length -1];}

	get firstDay() {return this._days[0];}
	get lastDay() {return this._days[this._days.length -1];}

	get firstMonth() {return this._months[0];}
	get lastMonth() {return this._months[this._months.length - 1];}

	init() {
		let refTime = this._scale.start;
		let refDateTime = new Date(refTime);

		this._marks.push(ScaleBarMark.seed(this, refTime));
		this._days.push(ScaleDay.seed(this, refDateTime));
		this._months.push(ScaleMonth.seed(this, refDateTime));
		this.update();
	}

	scaleChange() {
		this._months.forEach((month) => month.size());
		this._days.forEach((day) => day.size());
		this._marks[0].findMinor();
		for(let a = 1, aa = this._marks.length; a < aa; a++) {
			this._marks[a].time = this._marks[a-1].time + this._scale.minor;
		}
	}

	update() {
		// position all elements
		while (this.lastMark.end < this._scale.end) this._marks.push(ScaleBarMark.after(this, this.lastMark));
		while (this._scale.start < this.firstMark.start) this._marks.unshift(ScaleBarMark.before(this, this.firstMark));
		while (this.lastDay.end < this._scale.end) this._days.push(ScaleDay.after(this, this.lastDay));
		while (this._scale.start < this.firstDay.start) this._days.unshift(ScaleDay.before(this, this.firstDay));
		while (this.lastMonth.end < this._scale.end) this._months.push(ScaleMonth.after(this, this.lastMonth));
		while (this._scale.start < this.firstMonth.start) this._months.unshift(ScaleMonth.before(this, this.firstMonth));

		while (this._scale.end < this.lastMark.start && 1 < this._marks.length) this._marks.pop().dispose();
		while (this.firstMark.end < this._scale.start && 1 < this._marks.length) this._marks.shift().dispose();
		while (this._scale.end < this.lastDay.start && 1 < this._days.length) this._days.pop().dispose();
		while (this.firstDay.end < this._scale.start && 1 < this._days.length) this._days.shift().dispose();
		while (this._scale.end < this.lastMonth.start && 1 < this._months.length) this._months.pop().dispose();
		while (this.firstMonth.end < this._scale.start && 1 < this._months.length) this._months.shift().dispose();

		for (let mark of this._marks) mark.move();
		for (let day of this._days) day.move();
		for (let month of this._months) month.move();
	}
}